var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fee-table" },
    [
      _c("div", { staticClass: "single-transaction" }, [
        _vm._v("Single Transaction Amount"),
      ]),
      _vm._l(_vm.feeData, function (channel) {
        return _c(
          "div",
          { key: channel.channel_name, staticClass: "channel" },
          [
            _c("div", { staticClass: "first-col" }, [
              _c("div", { staticClass: "channel-name" }, [
                _vm._v(_vm._s(channel.channel_name)),
              ]),
            ]),
            _c(
              "div",
              {
                staticClass: "other-col",
                class: {
                  "other-col-border":
                    _vm.compChannelFee(channel.channel_sub_templates).length >
                    2,
                },
              },
              _vm._l(
                _vm.compChannelFee(channel.channel_sub_templates),
                function (feeItem) {
                  return _c(
                    "div",
                    { key: feeItem.id, staticClass: "fee-col" },
                    [
                      _c("div", { staticClass: "row-1" }, [
                        _vm._v(_vm._s(_vm.compScope(feeItem))),
                      ]),
                      _c("div", { staticClass: "row-2" }, [
                        _vm._v(_vm._s(_vm.compNumber(feeItem)) + " "),
                      ]),
                    ]
                  )
                }
              ),
              0
            ),
          ]
        )
      }),
      _c("div", { staticClass: "fee-tip" }, [
        _vm._v(" The fees are determined by the transaction amount "),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }